/**
 * Configuracao MSAL para Azure AD SSO.
 *
 * Quando VITE_AZURE_AD_ENABLED !== 'true', msalConfig sera null
 * e nenhum import de @azure/msal-browser e executado.
 */

import { PublicClientApplication } from '@azure/msal-browser';

export const isAzureAdEnabled = import.meta.env.VITE_AZURE_AD_ENABLED === 'true';

const clientId = import.meta.env.VITE_AZURE_AD_CLIENT_ID || '';
const tenantId = import.meta.env.VITE_AZURE_AD_TENANT_ID || 'common';

const msalConfig = isAzureAdEnabled
  ? {
      auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: window.location.origin + '/login',
        navigateToLoginRequestUrl: false,
      },
      cache: {
        cacheLocation: 'sessionStorage' as const,
        storeAuthStateInCookie: false,
      },
    }
  : null;

export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
};

// Singleton MSAL instance
let msalInstance: PublicClientApplication | null = null;
let msalInitialized = false;

export async function getMsalInstance(): Promise<PublicClientApplication | null> {
  if (!msalConfig) return null;
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(msalConfig);
  }
  if (!msalInitialized) {
    await msalInstance.initialize();
    msalInitialized = true;
  }
  return msalInstance;
}

export default msalConfig;
